

























import { Component, Vue } from 'vue-property-decorator';
import PensionUnitSelectionNew from '@/components/PensionUnitSelection/PensionUnitSelectionNew.vue';

@Component({
  components: {
    PensionUnitSelectionNew,
  },
})
export default class PensionUnitSelectionNewButton extends Vue {
  private showDialog = false;
}
